import * as React from "react";
import { SignManager } from "./SignManager";
import * as oidc from "oidc-client";
import { Environment } from "./environments";

export interface SignProviderProps {
  environment: Environment;
  user: oidc.User | undefined | null;
  children: ((signManager: SignManager) => React.ReactNode) | React.ReactNode;
}

export interface SignProviderState {}

export class SignProvider extends React.Component<SignProviderProps, SignProviderState> {
  private signManager: SignManager;

  constructor(props: SignProviderProps) {
    super(props);
    this.signManager = new SignManager({
      environment: props.environment,
      getAccessToken: async () => (this.props.user ? this.props.user.access_token : ""),
      getIdToken: async () => (this.props.user ? this.props.user.id_token : "")
    });
  }

  public render() {
    const renderedChildren =
      typeof this.props.children === "function"
        ? (this.props.children as any)(this.signManager)
        : this.props.children;

    return <SignContext.Provider value={this.signManager}>{renderedChildren}</SignContext.Provider>;
  }
}

type SignContextData = null | SignManager;

export const SignContext = React.createContext<SignContextData>(null);

export const SignConsumer = SignContext.Consumer;
